module.exports = __webpack_public_path__ + "img/vrmetavers.d17c8bf4.svg";